<template>
        <div class="row">
            <div class="col-12 col-sm-12">
                <price-search-contract-length-selector/>
                <price-search-annual-mileage-selector/>
            </div>
        </div>
</template>

<script>
  import {Vue, Component} from 'vue-property-decorator';
  import PriceSearchAnnualMileageSelector from "./PriceSearchAnnualMileageSelector";
  import PriceSearchContractLengthSelector from "./PriceSearchContractLengthSelector";

  @Component({
    components: {
      PriceSearchContractLengthSelector,
      PriceSearchAnnualMileageSelector
    }
  })

  export default class PriceFilterForm extends Vue {}
</script>